import React, {forwardRef} from "react"
import OptionText from "../../../../generic/dropdown/components/option/option-text"
import {PopoverMenuOptionProps} from "../../../../generic/dropdown/components/option/option"
import {NO_TYPE_COLOR} from "./value/value-empty"

/**
 * The contact type option reads like the field value - a color box plus the plain type name, no pill.
 *
 * GOTCHA: DropdownPopoverOptionsSelector keeps a ref to every option and scrolls to it via findDOMNode -
 * the ref is forwarded to the wrapping div, OptionText takes none.
 */
const FieldCrmContactType_PopoverOption = forwardRef<HTMLDivElement, PopoverMenuOptionProps>((props, ref)=> {

    // the no value option (value null) has no color in the settings - it gets the empty value's one
    const color = _.isNil(props.option.value) ? NO_TYPE_COLOR : props.option.color

    const option = {
        ...props.option,
        iconComponent   : <div className={Classes("ui5-color-box m-r-8", "gd-c-{0}".f(color))}/>
    }

    return (
        <div ref={ref}>
            <OptionText
                option              = {option}
                isHighlighted       = {props.isHighlighted}
                isSelected          = {props.isSelected}
                onSetHelpMessage    = {props.onSetHelpMessage}
                onClick             = {props.onClick}
            />
        </div>
    )
})

export default FieldCrmContactType_PopoverOption
